import InstanceApi from "@/services/apiClient.js";
import Messages from "@/components/Messages/Messages.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      form: {
        email: "",
        password: "",
      },
      errorMessages: "",
    };
  },

  computed: {
    ...mapGetters({ storeUrlPrefix: "getStoreUrlPrefix" }),
  },

  components: {
    Messages,
  },

  methods: {
    async login(shouldReload) {
      try {
        const loginUrl = "mcp/account/loginPost";
        var formData = new FormData();
        formData.append("email", this.formValidations.emailLogin);
        formData.append("password", this.formValidations.password);
        const response = await InstanceApi.post(loginUrl, formData);
        if (response.data.messages && response.data.messages.error.length > 0) {
          this.errorMessages = response.data.messages.error;
        } else {
          this.errorMessages = "";
          
          if (shouldReload === true) {
            location.reload();
          }
          
          this.setCurrentUserIsLoggedIn(true);
          let formattedUser = response.data;
          formattedUser["shipping_address"] = [response.data.shipping_address];
          formattedUser["billing_address"] = [response.data.billing_address];
          this.setCurrentUser(formattedUser);
          this.closeModal();
        }
      } catch (error) {
        this.$fire({
          title: "Oups",
          text: "Une erreur est survenu lors de la connection",
          type: "error",
          timer: 1500,
          position: "top-end",
        });
      }
    },
    ...mapActions(["setCurrentUserIsLoggedIn", "setCurrentUserIsLoggedIn"]),
    ...mapActions(["setCurrentUser", "setCurrentUser"]),
  },
};
